import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { SubjectType } from "../../../types/Subject";

const initialState: SubjectType = {
    id: "",
    description: "",
    precedence: "",
    isCore: false,
    hasExam: false,
    idScientificArea: "",
    status: false
};
export const subjectSlice = createSlice({
    name: "subjectForm",
    initialState,
    reducers: {
        setUpdateSubjectData: (
            state, action: PayloadAction<SubjectType>,
        ) => {
            return { ...state, ...action.payload };
        },
        resetUpdateSubjectData: (
            state,
        ) => {
            return initialState
        }
    }
});
export const { setUpdateSubjectData,resetUpdateSubjectData } = subjectSlice.actions;
export default subjectSlice.reducer;